import API from "./api";

export const sendRequest = async (username) => {
  try {
    const res = await API.put(`/message/send/${username}`);
    return res.data;
  } catch (err) {
    throw err;
  }
};

export const cancelRequest = async (username) => {
  try {
    const res = await API.put(`/message/cancel/${username}`);
    return res.data;
  } catch (err) {
    throw err;
  }
};

export const acceptRequest = async (username) => {
  try {
    const res = await API.put(`/message/accept/${username}`);
    return res.data;
  } catch (err) {
    throw err;
  }
};

export const rejectRequest = async (username) => {
  try {
    const res = await API.put(`/message/reject/${username}`);
    return res.data;
  } catch (err) {
    throw err;
  }
};
